export class TidalGlobalModel {

    /**
     * Exchange rate
     */
    exchange_rate: bigint = BigInt(0);

    /**
     * Buy rate
     */
    buy_rate: bigint = BigInt(0);

    /**
     * Sell rate
     */
    sell_rate: bigint = BigInt(0);

    /**
     * Expiry rate
     */
    expiry_rate: bigint = BigInt(0);

    /**
     * Exchange coins
     */
    exchange_coins: bigint = BigInt(0);

    /**
     * Exchange shares
     */
    exchange_shares: bigint = BigInt(0);

    /**
     * Fill values
     * 
     * @param values 
     */
    fill(values: Array<any>) {
        this.exchange_rate = this.format(values, 'exchange_rate');
        this.buy_rate = this.format(values, 'buy_rate');
        this.sell_rate = this.format(values, 'sell_rate');
        this.expiry_rate = this.format(values, 'expiry_rate');
        this.exchange_coins = this.format(values, 'exchange_coins');
        this.exchange_shares = this.format(values, 'exchange_shares');
    }

    /**
     * Format value
     * 
     * @param values
     * @param app
     * @param key
     */
    private format(values: Array<any>, key: string): bigint {
        let value = values.find(x => x.key == 'tidal_' + key);
        if (value) {
            return BigInt(value.value);
        } else {
            return BigInt(0);
        }
    }
}